import * as React from "react";

export function useAnimatedUnmount(isMounted: boolean, delayTime: number) {
  const mountedStyle: React.CSSProperties = {
    maxHeight: "100vh",
    overflow: "hidden",
    transition: `max-height ${delayTime}ms ease-in-out`,
  };
  const unmountedStyle: React.CSSProperties = {
    maxHeight: 0,
    overflow: "hidden",
    transition: `max-height ${delayTime}ms cubic-bezier(0, 1, 0, 1)`,
  };
  const delayTimeToMountAnimation = 10;

  const [style, setStyle] = React.useState<React.CSSProperties>();
  const [showComponent, setShowComponent] = React.useState<boolean>();

  React.useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isMounted) {
      setShowComponent(true);
      timeoutId = setTimeout(() => setStyle(mountedStyle), delayTimeToMountAnimation);
    } else {
      timeoutId = setTimeout(() => setShowComponent(false), delayTime);
      setStyle(unmountedStyle);
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted]);
  return { showComponent, style };
}

interface AnimatedUnmountWrapperProps {
  isMounted: boolean;
  delayTime: number;
}

export const AnimatedUnmountWrapper: React.FC<AnimatedUnmountWrapperProps> = props => {
  const { showComponent, style } = useAnimatedUnmount(props.isMounted, props.delayTime);

  return showComponent ? <div style={style}>{props.children}</div> : null;
};
